<script lang="ts">
  import clsx from "clsx";
  import SvgHome from "$assets/svg/home.svg?src";
  import SvgSeach from "$assets/svg/search.svg?src";
  import SvgAdd from "$assets/svg/add-square.svg?src";
  import SvgLive from "$assets/svg/live.svg?src";
  import SvgWallet from "$assets/svg/wallet.svg?src";
  import landingPageStore from "@/stores/landingPageStore";
  import { INSTALL_REFERRER } from "@/constants/constants";
  import type { TBottombarItem } from "@/types/bottombar.types";
  import BottomSheet from "../organisms/BottomSheet.svelte";
  import SvgWrapper from "../atoms/SvgWrapper.svelte";
  import InstallButton from "./InstallButton.svelte";
  import trackEvents from "@/events";
  import EVENTS from "@/events/events";

  $: showHardNudge = $landingPageStore.showHardNudge;
  $: selectedItem = $landingPageStore.selectedItem;

  const showBottomSheet = () => {
    landingPageStore.updateState({
      showHardNudge: true,
    });
  };

  const hideBottomSheet = () => {
    landingPageStore.updateState({
      showHardNudge: false,
    });
  };

  const bottomBarItems: TBottombarItem[] = [
    {
      icon: SvgHome,
      label: "home",
      title: "",
    },
    {
      icon: SvgSeach,
      label: "explore",
      title: "Explore more categories!",
      action: showBottomSheet,
      referer: INSTALL_REFERRER.EXPLORE_NUDGE,
    },
    {
      icon: SvgAdd,
      label: "create",
      title: "Join Moj creator community!",
      action: showBottomSheet,
      referer: INSTALL_REFERRER.CREATION_NUDGE,
    },
    {
      icon: SvgLive,
      label: "live",
      title: "Catch your favourite creators Live!",
      action: showBottomSheet,
      referer: INSTALL_REFERRER.LIVE_NUDGE,
      text: "LIVE",
    },
    {
      icon: SvgWallet,
      label: "wallet",
      title: "",
      link: "/wallet",
    },
  ];

  const onItemClick = (item: TBottombarItem) => {
    trackEvents(EVENTS.PWA_BOTTOMBAR_CLICK, {
      bottombarItem: item.label,
    });
    if (showHardNudge || !item.action) return;
    landingPageStore.updateState({
      selectedItem: item,
    });
    item.action();
  };

  const trackCtaClick = () => {
    trackEvents(EVENTS.PWA_BOTTOMBAR_NUDGE_ACTION, {
      bottombarItem: selectedItem?.label,
      isDownloadCtaClick: true,
    });
  };
</script>

<div
  class="w-full absolute bottom-0 m-auto max-w-[600px] z-10 bg-black flex items-center justify-between"
  on:click|stopPropagation
>
  {#each bottomBarItems as item}
    <div
      class={clsx(
        "m-4 flex-1 flex justify-center z-50 cursor-pointer",
        showHardNudge && "pointer-events-none"
      )}
      on:click={() => onItemClick(item)}
    >
      {#if item.text}
        <span
          class="absolute top-[7px] bg-white rounded-sm font-semibold text-[8px] h-[11px] px-[2px]"
          >{item.text}</span
        >
      {/if}
      {#if item.link}
        <a href={item.link}>
          <SvgWrapper
            className="h-6 w-6"
            svg={item.icon}
            ariaLabel={item.label}
          />
        </a>
      {:else}
        <SvgWrapper
          className="h-6 w-6"
          svg={item.icon}
          ariaLabel={item.label}
        />
      {/if}
    </div>
  {/each}
</div>

<div class="absolute h-[calc(100%-56px)] w-full overflow-hidden">
  <BottomSheet show={showHardNudge} onClose={hideBottomSheet}>
    <div
      class="flex flex-col items-center px-4 pb-8 pt-12 font-primary text-center"
    >
      <img
        src="/assets/icons/xhdpi.png"
        class="absolute top-0 -translate-y-2/4"
        alt="Moj"
        width="80"
        height="80"
      />
      <div class="text-text-primary font-bold text-xl">
        {selectedItem?.title}
      </div>
      <div class="text-text-primary font-semibold text-sm mt-2 mb-4">
        Download the Moj app now to enjoy this feature.
      </div>
      <div on:click={trackCtaClick} class="w-full">
        <InstallButton
          style="w-full font-bold text-base rounded-lg p-3 bg-brand-yellow text-black cursor-pointer"
          label="Get the Moj app"
          source={selectedItem?.referer}
          referrer={selectedItem?.referer}
        />
      </div>
    </div>
  </BottomSheet>
</div>
